window.addEventListener('scroll', () => {
  const stickyHeader = document.querySelector('.sticky-header'); // ✅ Fix from before
  const header = stickyHeader?.querySelector('.header');
  const mediaItems = document.querySelectorAll('.grid__item.product__media-wrapper');
  const badges = document.querySelectorAll('.product-page-badges');
  const topElements = document.querySelectorAll('.top_elements');
  const purchaseOptions = document.querySelectorAll('.purchase_option');
  const sadaqaLabels = document.querySelectorAll('.form__label.sadaqa'); // ✅ New

  if (window.scrollY > 0) {
    header?.classList.add('scrolled');
    mediaItems.forEach(item => item.classList.add('scrolled-media'));
    badges.forEach(badge => badge.classList.add('scrolled-badge'));
    topElements.forEach(el => el.classList.add('scrolled-top'));
    purchaseOptions.forEach(option => option.classList.add('scrolled-option'));
    sadaqaLabels.forEach(label => label.classList.add('scrolled-sadaqa')); // ✅ New
  } else {
    header?.classList.remove('scrolled');
    mediaItems.forEach(item => item.classList.remove('scrolled-media'));
    badges.forEach(badge => badge.classList.remove('scrolled-badge'));
    topElements.forEach(el => el.classList.remove('scrolled-top'));
    purchaseOptions.forEach(option => option.classList.remove('scrolled-option'));
    sadaqaLabels.forEach(label => label.classList.remove('scrolled-sadaqa')); // ✅ New
  }
});


let hasAddedContinueBag = false;
let hasAddedContinueMores = false;
let lastScrollTop = 0;

$(window).on('scroll resize', function() {
  const $el = $('.purchase_option.scrolled-option');
  if ($el.length === 0) return;

  const windowHeight = $(window).height();
  const scrollTop = $(window).scrollTop();
  const elementOffset = $el.offset().top;
  const elementHeight = $el.outerHeight();

  const isInViewport = (
    elementOffset + elementHeight >= scrollTop &&
    elementOffset <= scrollTop + windowHeight
  );

  if (!isInViewport) {
    if (!hasAddedContinueBag) {
      $el.addClass('continue_bag');
      hasAddedContinueBag = true;
      lastScrollTop = scrollTop;
    } else if (!hasAddedContinueMores && scrollTop > lastScrollTop + 30) { // 30px buffer
      $el.addClass('continue_mores');
      hasAddedContinueMores = true;
    }
  } else {
    $el.removeClass('continue_bag continue_mores');
    hasAddedContinueBag = false;
    hasAddedContinueMores = false;
  }
});

// Run once on load
$(document).ready(function() {
  $(window).trigger('scroll');
});
